"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FactPercentageIcon;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function FactPercentageIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    opacity: "0.5"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 2H15.4375V15.4375H2V2Z",
    stroke: "#AAACAE",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 6.03125H5.35937",
    stroke: "#AAACAE",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 12.75H6.03125V15.4375",
    stroke: "#AAACAE",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.4062 11.4062H15.4375",
    stroke: "#AAACAE",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.4375 5.35937H10.7344V2",
    stroke: "#AAACAE",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.04687 2V9.39062H4.6875",
    stroke: "#AAACAE",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.4062 9.39062V15.4375",
    stroke: "#AAACAE",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}